// src/components/Header.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes, FaHammer } from "react-icons/fa";
import useScrollAndNavigate from '../hooks/useScrollAndNavigate';
import BathroomLeadPopup from "./BathroomLeadPopup";
import './Header.css';

const Header = () => {
  const [scroll, setScroll] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showLeadPopup, setShowLeadPopup] = useState(false);
  const scrollAndNavigate = useScrollAndNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", updateIsMobile);
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []);

  const toggleMobileMenu = () => setMobileMenuOpen(!mobileMenuOpen);

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/calculator', label: 'Calculator' },
    { to: '/remodel-rates', label: 'Remodel Rates' },
    { to: '/remodel-planner', label: 'Remodel Planner' },
    { to: '/remodel-process', label: 'Remodel Process' },
    { to: '/about', label: 'About' },
    { to: '/contact-us', label: 'Contact' },
  ];

  return (
    <>
      {/* Theme color bar */}
      <div style={{ height: '4px', background: 'linear-gradient(90deg, #FF7A30 0%, #FFB347 100%)' }} />
      <nav className={`navbar ${scroll > 10 ? 'scrolled' : ''}`} style={{ backgroundColor: `rgba(10, 90, 160, ${Math.min(0.3 + scroll * 0.005, 0.9)})` }}>
        <div className="navbar-content">
          <Link to="/" onClick={(e) => { e.preventDefault(); scrollAndNavigate('/'); }}>
            <img src="/Bath.png" alt="Logo" className="logo" />
          </Link>
          <div className="nav-links">
            {navLinks.map(link => (
              <Link key={link.to} to={link.to} className="nav-link" onClick={(e) => { e.preventDefault(); scrollAndNavigate(link.to); }}>
                {link.label}
              </Link>
            ))}
          </div>
          {!isMobile && (
            <div className="nav-buttons">
              <button
                onClick={() => setShowLeadPopup(true)}
                className="quote-button"
              >
                Get Started Now
              </button>
            </div>
          )}
        </div>
        <button className="menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle Menu">
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        {isMobile && !mobileMenuOpen && (
          <div className="mobile-icons">
            <FaHammer onClick={() => setShowLeadPopup(true)} className="icon" />
          </div>
        )}
        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 z-50 flex items-start justify-end bg-black/30 md:hidden animate-fade-in">
            <div className="w-4/5 max-w-xs bg-white rounded-l-2xl shadow-2xl p-6 pt-4 flex flex-col gap-4 h-full relative">
              <button
                className="absolute top-3 right-3 p-2 rounded-full hover:bg-orange-50 text-orange-600"
                onClick={() => setMobileMenuOpen(false)}
                aria-label="Close Menu"
              >
                <FaTimes size={24} />
              </button>
              <nav className="flex flex-col gap-3 mt-4">
                {navLinks.map(link => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-lg font-semibold text-gray-700 hover:text-orange-600 px-2 py-2 rounded transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.label}
                  </Link>
                ))}
              </nav>
              <button
                onClick={() => { setShowLeadPopup(true); setMobileMenuOpen(false); }}
                className="mt-6 bg-orange-600 hover:bg-orange-700 text-white px-5 py-3 rounded-lg font-bold shadow transition text-lg"
              >
                Get Free Quote
              </button>
              <div className="flex-1" />
              <div className="text-xs text-gray-400 text-center mt-8">&copy; {new Date().getFullYear()} LocalBathQuotes</div>
            </div>
          </div>
        )}
        {showLeadPopup && (
          <BathroomLeadPopup isOpen={showLeadPopup} onClose={() => setShowLeadPopup(false)} />
        )}
      </nav>
    </>
  );
};

export default Header;

/* Add this to your CSS or Tailwind config for fade-in:
.animate-fade-in { animation: fadeIn 0.25s ease; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
*/
